
import React, { createContext, useContext, useEffect } from "react";
import { AuthContextType } from "./auth/types";
import { useAuthState } from "./auth/useAuthState";
import { useEmailVerification } from "./auth/useEmailVerification";
import { useAuthOperations } from "./auth/useAuthOperations";

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { user, session, loading, setLoading } = useAuthState();
  const { handleEmailVerification } = useEmailVerification();
  const { signIn, signUp, signOut } = useAuthOperations(setLoading);

  useEffect(() => {
    // Check for verification immediately
    handleEmailVerification();
  }, []);

  return (
    <AuthContext.Provider value={{ session, user, signIn, signUp, signOut, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
